import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { AppProviders } from './app/providers.js';
import { createRouter } from './app/router.js';
import { registerServiceWorker } from './lib/pwa.js';
import './styles/theme.css';

/**
 * Application entry point.
 *
 * `index.html` already paints the wordmark and a first-paint background, so this
 * module's job is only to hydrate the interactive app over the top. Nothing here
 * blocks on the API, the CMS or WebGL.
 */

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root was not found in index.html.');
}

void registerServiceWorker();

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={createRouter()} />
    </AppProviders>
  </StrictMode>,
);
